'use client'

import { Button, Image } from '@vinted/web-ui'

import { ShowAtBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  landingPageEvent,
  InfluencerLandingPageEvent,
  InfluencerImageModel,
  InfluencerIntroductionModel,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'

type Props = {
  data: InfluencerIntroductionModel
}

// TODO: update the section with the new design
export const NewIntroductionSection = ({
  data: { title, description, ctaText, ctaUrl, imageMobile, imageWeb, videoUrl },
}: Props) => {
  const { track } = useTracking()

  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: InfluencerLandingPageEvent.FollowClosetCtaClick,
        targetDetails: ctaUrl,
        deviceId: await getFingerprint(),
      }),
    )

  const renderHeroImage = (image: InfluencerImageModel) => (
    <div className="influencer-v2__introduction-image">
      <Image
        src={image.x2Url}
        scaling="cover"
        testId="introduction-section-image"
        srcset={`${image.x1Url} 1x, ${image.x2Url} 2x, ${image.x3Url} 3x`}
      />
    </div>
  )

  return (
    <section className="influencer-v2_introduction-section" data-testid="introduction-section">
      <h1 className="influencer-v2__introduction-title">{title}</h1>
      <div className="influencer-v2__introduction-content">
        {videoUrl ? (
          <iframe
            src={videoUrl}
            title={title}
            className="influencer-v2__introduction-video-iframe"
            allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            data-testid="influencer-intro_video"
          />
        ) : (
          <>
            <ShowAtBreakpoint breakpoint="portables">
              {renderHeroImage(imageMobile)}
            </ShowAtBreakpoint>
            <ShowAtBreakpoint breakpoint="desktops">{renderHeroImage(imageWeb)}</ShowAtBreakpoint>
          </>
        )}
        <p className="influencer-v2__introduction-description">{description}</p>
        <div className="influencer-v2__introduction-cta">
          <Button
            styling="filled"
            text={ctaText}
            url={ctaUrl}
            onClick={handleOnCtaClick}
            testId="influencer__introduction-cta"
          />
        </div>
      </div>
    </section>
  )
}
